import { Grid } from "@mui/material";

import "./style.css";
// import Story from "../../Assets/Img/instastory.svg";

import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Breadcrump from "../../../Common/Components/Breadcrumb";
import axiosMain from "../../../http/axiosMain";
import ContentPosted from "./components/contentPosted";
import Engagement from "./components/engagement";
import TotalReach from "./components/totalReach";

const YoutubeInsights = () => {
  const [campaignLoading, setCampaignLoading] = useState(true);
  const [campaigns, setCampaigns] = useState([]);

  const getCampaigns = async () => {
    try {
      setCampaignLoading(true);
      const resp = await axiosMain.get("api/v1/campaigns?throw_error=false");
      if (resp.status === 200 && resp.data?.campaigns?.length) {
        setCampaigns(resp.data?.campaigns);
      } else {
        toast.error(resp.data?.message || "Something went wrong", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.message || err?.message || "Something went wrong",
        {
          position: "top-right",
          autoClose: 3000,
        }
      );
    } finally {
      setCampaignLoading(false);
    }
  };

  useEffect(() => {
    getCampaigns();
  }, []);

  return (
    <>
      <Breadcrump />
      <div className="State wrapping-box youtube">
        <div className="wrapping-box-content">
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            <Grid item xs={12} sm={12} md={4}>
              <Engagement campaigns={campaigns} loading={campaignLoading} />
            </Grid>
            <Grid item xs={12} sm={12} md={8}>
              <ContentPosted campaigns={campaigns} loading={campaignLoading} />
            </Grid>
          </Grid>

          <div className="mt-3">
            <TotalReach />
          </div>
        </div>
      </div>
    </>
  );
};

export default YoutubeInsights;
